import React from 'react'

// COMPONENTS
import Directory from '../../components/Directory/Directory.component'

const Home = () => {
  return (
    <div>
      <Directory />
    </div>
  )
}

export default Home
